module.exports = __webpack_public_path__ + "static/phoenix_art-06c650fc7e3d7eea912424b13d4655e7.jpg";